import { Tooltip } from '@assembly-js/design-system';
import { t } from 'i18next';
import React from 'react';

import { GemIcon } from 'src/components/icons';

/**
 * Gem badge marking a nav row whose feature needs a plan upgrade. Its gray is
 * the row's hover background too, so it lightens on hover to stay visible —
 * read off the row itself (see `SidebarListItem`) rather than threaded down.
 * The selected row is darker than the badge, so it needs no such treatment.
 */
export const StudioUpgradeBadge: React.FC = () => (
  <Tooltip
    content={t(($) => $.page_studio_plans.choose_plan.upgrade)}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    baseOffset={4}
    showDelayDuration={100}
  >
    <span
      data-testid="studio-upgrade-badge"
      className="inline-flex items-center rounded bg-secondary-hover px-1 py-[3px] group-hover:bg-gray-100"
    >
      <GemIcon className="text-black-heading" style={{ fontSize: 14 }} />
    </span>
  </Tooltip>
);
